import { z } from 'zod';

export const knowledgeBaseSchema = z.object({
  question: z.string().min(1, 'Question is required'),
  answer: z.string().min(1, 'Answer is required'),
});

export type KnowledgeBaseFormData = z.infer<typeof knowledgeBaseSchema>;
